// @ts-nocheck

(function () {
  function appendRow(tbody, label, value) {
    const tr = document.createElement('tr');
    tr.className = 'crmTableTr';

    const tdLabel = document.createElement('td');
    tdLabel.className = 'bold-text crmTableTd';
    tdLabel.textContent = label;

    const tdValue = document.createElement('td');
    tdValue.className = 'crmTableTd';
    tdValue.textContent = value;

    tr.appendChild(tdLabel);
    tr.appendChild(tdValue);
    tbody.appendChild(tr);
  }

  function buildRequirementsTable(variantData) {
    const table = document.createElement('table');
    table.className = 'crmTable';
    const tbody = document.createElement('tbody');
    let publisher_name = '';
    let ebook_format = '';

    if (
      variantData?.metafields &&
      Array.isArray(variantData.metafields) &&
      variantData.metafields.length > 0
    ) {
      variantData.metafields.forEach((field) => {
        const value = field;
        if (!value) return;

        if (value.hasOwnProperty('publisher_name') && value.namespace === 'cm_digital') {
          publisher_name = value.publisher_name;
          appendRow(tbody, 'Publisher', value.publisher_name);
        }
        if (value.hasOwnProperty('ebook_format') && value.namespace === 'cm_digital') {
          ebook_format = value.ebook_format;
          appendRow(tbody, 'Format', value.ebook_format);
        }
        if (
          value.hasOwnProperty('download_provider_name') &&
          value.namespace === 'cm_digital'
        ) {
          appendRow(tbody, 'Download Provider', value.download_provider_name);
        }
        if (value.hasOwnProperty('isbn') && value.namespace === 'cm_digital') {
          appendRow(tbody, 'Digital ISBN', value.isbn);
        }
        if (value.hasOwnProperty('refundable') && value.namespace === 'cm_digital') {
          appendRow(tbody, 'Refundable', value.refundable === 'true' ? 'Yes' : 'No');
        }
        if (value.hasOwnProperty('partial_content') && value.namespace === 'cm_digital') {
          appendRow(
            tbody,
            'Partial Content',
            value.partial_content === 'true' ? 'Yes' : 'No'
          );
        }
        if (value.hasOwnProperty('subscription') && value.namespace === 'cm_digital') {
          const subscription = String(value.subscription || '').trim();
          if (subscription !== '0' && subscription !== '999') {
            appendRow(tbody, 'Available to Rent?', value.subscription);
          }
        }
        if (value.hasOwnProperty('print_limit') && value.namespace === 'cm_digital') {
          appendRow(tbody, 'Print Limit', value.print_limit);
        }
        if (value.hasOwnProperty('copy_paste_limit') && value.namespace === 'cm_digital') {
          appendRow(tbody, 'Copy/Paste Limit', value.copy_paste_limit);
        }
        if (
          value.hasOwnProperty('device_sharing_limit') &&
          value.namespace === 'cm_digital'
        ) {
          appendRow(tbody, 'Device Sharing Limit', value.device_sharing_limit);
        }
        if (value.hasOwnProperty('access') && value.namespace === 'cm_digital') {
          appendRow(tbody, 'Access', value.access);
        }
      });
    }

    table.appendChild(tbody);

    return {
      table,
      publisher_name,
      ebook_format,
      subtitle: `${publisher_name} on ${ebook_format}`.replace(/^ on $/, '').trim(),
    };
  }

  function buildRequirementsSubtitle(productTitle, publisherName, ebookFormat) {
    const title = productTitle || '';
    const publisher = publisherName || '';
    const format = ebookFormat || '';

    if (publisher && format) {
      return `${title} - ${publisher} on ${format}`;
    }

    return title;
  }

  window.cmrpBuildRequirementsTable = buildRequirementsTable;
  window.cmrpBuildRequirementsSubtitle = buildRequirementsSubtitle;
})();
